import { useSelector } from 'react-redux'
import { dialogSearchQuerySelector } from '../selectors'

export function useDialogSearchQuery() {
  return useSelector(dialogSearchQuerySelector)
}
